define('app/sdc/safe/apply/sdc-safe-apply-factory',["$rootScope"], function ($rootScope) {
	return function safeApplyFactory($scope) {
		$scope = $scope || $rootScope;
		return function safeApply(fn) {
			if ($rootScope.$$phase) {
				return $scope.$eval(fn);
			}
			else {
				return $scope.$apply(fn);
			}
		}
	};
});
